import React from "react";
import TopCards from "./TopCards";
import DiseaseChart from "./DiseaseChart";
import Appointment from "./Appointment";
import Medicines from "./Medicines";
import Patient from "./Patient";
import Doctors from "./Doctors";

const Dashboard = () => {
  return (
    <div className="flex flex-col gap-5">
      <TopCards />
      <div className="grid lg:grid-cols-3 gap-5">
      <DiseaseChart />
      <Appointment/>
      <Medicines />
      </div>
      <div className="grid lg:grid-cols-2 gap-5">
      <Patient/>
      <Doctors/>
      </div>
    </div>
  );
};

export default Dashboard;
